import http from '@/service/http'
import findIndex from 'lodash/findIndex'
import VueLocalForage from 'localforage'

const save = async (context, obj) => {
  const { verb, usuario } = obj
  const response = await http[verb]('/usuario', usuario)

  if (response !== null) {
    if (response.data.data !== undefined) {
      usuario.id = response.data.data.id
      update(context, { ...usuario })
    }
    return Promise.resolve()
  }
}

const saveRegistro = (context, obj) => {
  return new Promise(async (resolve) => {
    const { verb, usuario } = obj
    const response = await http[verb]('/usuario', usuario)
    if (response !== null) {
      if (response.data.data !== undefined) {
        const token = response.data.data.token
        VueLocalForage.setItem('I-INA-SYSTEM', token)
        update(context, { ...usuario })
        const message = response.data
        resolve(message)
      } else {
        if (response.data instanceof String) {
          const message = response.data
          resolve(message)
        } else {
          Promise.resolve(response.data)
        }
      }
    }
  })
}

const solicitarVerificacaoDados = (context, obj) => {
  return new Promise(async (resolve) => {
    const { verb, usuario } = obj
    const response = await http[verb]('/usuario/solicitarVerificacaoDados', usuario)
    if (response !== null) {
      const message = response.data.data
      resolve(message)
    }
  })
}

const solicitarNovoEmailVerificacao = (context, obj) => {
  return new Promise(async (resolve) => {
    const { verb, usuario } = obj
    const response = await http[verb]('/usuario/solicitarNovoEmailVerificacao', usuario)
    if (response !== null) {
      const message = response.data.data
      resolve(message)
    }
  })
}

const solicitarRedefinicaoSenha = (context, obj) => {
  return new Promise(async (resolve) => {
    const { verb, usuario } = obj
    const response = await http[verb]('/usuario/solicitarRedefinicaoSenha', usuario)
    if (response !== null) {
      if (response.data instanceof String) {
        const message = response.data
        resolve(message)
      } else {
        const message = response.data.message
        resolve(message)
      }
    }
  })
}

const alterarSenhaUsuario = (context, obj) => {
  return new Promise(async (resolve) => {
    const { verb, usuario } = obj
    const response = await http[verb]('/usuario/alterarSenhaUsuario', usuario)
    if (response !== null) {
      const message = response.data.data
      resolve(message)
    }
  })
}

const solicitarNovoCodigoSmsVerificacao = (context, obj) => {
  return new Promise(async (resolve) => {
    const { verb, usuario } = obj
    const response = await http[verb]('/usuario/solicitarNovoCodigoSmsVerificacao', usuario)
    if (response !== null) {
      const message = response.data.data
      resolve(message)
    }
  })
}

const checkCode = (context, obj) => {
  return new Promise(async (resolve) => {
    const { verb, usuario } = obj
    const response = await http[verb]('/usuario/checkCode', usuario)
    if (response !== null) {
      const message = response.data.data
      resolve(message)
    }
  })
}

const checkSelfie = (context, obj) => {
  return new Promise(async (resolve) => {
    const { verb, selfieData } = obj
    const response = await http[verb]('/usuario/checkSelfie', selfieData)
    if (response !== null) {
      const message = response.data.data
      resolve(message)
    }
  })
}

const banir = async (context, obj) => {
  // const { banido } = obj.usuario
  // let _self = obj.usuario
  // obj.usuario.banido = !banido
  // const { id } = obj.usuario.id
  const { verb, usuario } = obj
  const response = await http[verb]('/usuario/banir', usuario)
  if (response !== null) {
    // usuario.id = id
    // usuario.banido = !banido
    update(context, { ...usuario })
    return Promise.resolve()
  }
}

const fraude = async (context, obj) => {
  // const { fraude } = obj.usuario
  // let _self = obj.usuario
  const { verb, usuario } = obj
  const response = await http[verb]('/usuario/fraude', usuario)
  if (response !== null) {
    // usuario.id = _self.id
    // usuario.fraude = !fraude
    update(context, { ...usuario })
    return Promise.resolve()
  }
}

const vip = async (context, obj) => {
  const { verb, usuario } = obj
  const response = await http[verb]('/usuario/vip', usuario)
  if (response !== null) {
    update(context, { ...usuario })
    return Promise.resolve()
  }
}

const verificado = async (context, obj) => {
  const { verb, usuario } = obj
  const response = await http[verb]('/usuario/verificado', usuario)
  if (response !== null) {
    update(context, { ...usuario })
    return Promise.resolve()
  }
}

const problematico = async (context, obj) => {
  // const { problematico } = obj.usuario
  // let _self = obj.usuario
  const { verb, usuario } = obj
  const response = await http[verb]('/usuario/problematico', usuario)
  if (response !== null) {
    // usuario.id = _self.id
    // usuario.problematico = !problematico
    update(context, { ...usuario })
    return Promise.resolve()
  }
}

const fetchOne = async (context, id) => {
  const response = await http.get(`/usuario/${id}`)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const fetchUniqueOne = async (context, id) => {
  const response = await http.get(`/usuario/unique/${id}`)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const fetch = async ({ commit }, obj) => {
  const { pagina, quantidadePorPagina, filterField, filterValue } = obj
  var list = []
  commit('SET_LIST', list)
  let url = `/usuario/paginacao?pagina=${pagina}&por_pagina=${quantidadePorPagina}&filterField=${filterField}&filterValue=${filterValue}`
 
  const response = await http.get(`${url}`)
  if (response !== null) {
    const usuarios = response.data.data
    const paginas = response.data.data.quantidadeDePaginas
    commit('SET_QUANTIDADE_PAGINAS', paginas)
    if ((typeof (usuarios) !== 'undefined')) {
      commit('SET_LIST', usuarios)
    }
  }
}

const update = ({ commit, state }, obj) => {
  const index = findIndex(state.list, { id: obj.id })
  const payload = { usuario: obj, index }
  commit('SET_ONE', payload)
}

// const updateActions = ({ commit, state }, obj) => {
//   obj.banido = !obj.banido
//   const index = findIndex(state.list, { id: obj.id })
//   const payload = { usuario: obj, index }
//   commit('SET_ONE', payload)
// }

const remove = ({ commit, state }, obj) => {
  return new Promise(async (resolve) => {
    const { id } = obj
    const response = await http.delete(`/usuario/${id}`)
    const message = response.data.data
    const index = findIndex(state.list, { id })

    if (index > -1) {
      commit('REMOVE_ONE', { index })
    }

    resolve(message)
  })
}

const validateExists = async ({ commit }, values) => {
  // const response = await http.get(`/usuario/exists?field=${values.field}&value=${values.value}`)
  // if (response !== null) {
  //   commit('VALIDATE', { [values.field]: response.data.data.present })
  // }
}

export default {
  fetch,
  fetchOne,
  fetchUniqueOne,
  save,
  saveRegistro,
  solicitarVerificacaoDados,
  solicitarNovoEmailVerificacao,
  solicitarNovoCodigoSmsVerificacao,
  checkCode,
  checkSelfie,
  banir,
  fraude,
  vip,
  problematico,
  update,
  remove,
  solicitarRedefinicaoSenha,
  alterarSenhaUsuario,
  verificado,
  validateExists
}



// WEBPACK FOOTER //
// ./src/features/admin/usuarios/store/actions.js